// extracted by mini-css-extract-plugin
export default {"rangTableContainer":"RangTabela_rangTableContainer__uhIP7"};